// Volume - Lumber units with conversion factors to board foot
export const volumeLumberUnits = [
  { id: 'board-foot', name: 'Board Foot', symbol: 'BF', plural: 'Board Feet', factor: 1 },
  { id: 'thousand-board-feet', name: 'Thousand Board Feet', symbol: 'MBF', plural: 'Thousand Board Feet', factor: 1000 },
  { id: 'cord', name: 'Cord', symbol: 'cord', plural: 'Cords', factor: 768 },
  { id: 'cord-feet', name: 'Cord Feet', symbol: 'cord ft', plural: 'Cord Feet', factor: 96 },
  { id: 'cunit', name: 'Cunit', symbol: 'cunit', plural: 'Cunits', factor: 96 },
  { id: 'pallet', name: 'Pallet', symbol: 'pallet', plural: 'Pallets', factor: 16 },
  { id: 'cross-tie', name: 'Cross Tie', symbol: 'cross tie', plural: 'Cross Ties', factor: 3.5 },
  { id: 'switch-tie', name: 'Switch Tie', symbol: 'switch tie', plural: 'Switch Ties', factor: 6 },
  { id: 'cubic-meter', name: 'Cubic Meter', symbol: 'm³', plural: 'Cubic Meters', factor: 423.776 },
  { id: 'cubic-foot', name: 'Cubic Foot', symbol: 'ft³', plural: 'Cubic Feet', factor: 12 },
  { id: 'cubic-inch', name: 'Cubic Inch', symbol: 'in³', plural: 'Cubic Inches', factor: 0.00694444 },
];

export const popularVolumeLumberConversions = [
  { from: 'board-foot', to: 'cubic-foot' },
  { from: 'cubic-foot', to: 'board-foot' },
  { from: 'thousand-board-feet', to: 'board-foot' },
  { from: 'cord', to: 'board-foot' },
  { from: 'board-foot', to: 'cubic-meter' },
  { from: 'cubic-meter', to: 'board-foot' },
];

export const getUnitById = (id) => volumeLumberUnits.find(unit => unit.id === id);

export const convertVolumeLumber = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert lumber volume units and learn the conversion formula.`;
};
